import React from "react";
import {useHistory} from "react-router-dom";
import {useTranslation} from "@unibuddy/intl";
import {Button} from "@unibuddy/patron";
import {IconChevronLeft} from "@unibuddy/icons";

import {IntlNamespaces} from "../../../../../translations/types";
import {INTL_GO_BACK} from "../../../../../translations/chat";

export function ChatBackButton() {
    const {t} = useTranslation(IntlNamespaces.CHAT);
    const history = useHistory();
    return (
        <Button
            onClick={() => history.goBack()}
            iconOnly
            clear
            aria-label={t(INTL_GO_BACK.key, INTL_GO_BACK.defaultValue)}
        >
            <IconChevronLeft />
        </Button>
    );
}
